import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SearchState {
  loading: boolean
  recentSearches: string[]
}

const initialState: SearchState = {
  loading: false,
  recentSearches: [],
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    searchStart: (state) => {
      state.loading = true
    },
    logSearch: (state, action: PayloadAction<string>) => {
      const token = action.payload
      if (!state.recentSearches.includes(token)) {
        state.recentSearches.unshift(token)
        state.recentSearches = state.recentSearches.slice(0, 15)
      }
    },
    searchSuccess: (state) => {
      state.loading = false
    },
    searchFail: (state) => {
      state.loading = false
    },
    clearRecentSearches: (state) => {
      state.recentSearches = []
    },
    reset: () => initialState,
  },
})

export const searchActions = searchSlice.actions
export const searchReducer = searchSlice.reducer
// Export action type strings for backward compatibility
export const Types = Object.fromEntries(
  Object.entries(searchSlice.actions).map(([key, action]) => [
    key.replace(/([A-Z])/g, '_$1').toUpperCase().replace(/^_/, ''),
    action.type,
  ])
)
export default searchActions
